import React from "react";
import ReactDOM from "react-dom";

import NextApp from './NextApp';
import {unregister as unregisterServiceWorker} from './registerServiceWorker';
// Add this import:
import {AppContainer} from 'react-hot-loader';

import TagManager from 'react-gtm-module'
 
const tagManagerArgs = {
    gtmId: 'G-9D9728SS7K'
}
TagManager.initialize(tagManagerArgs)

 
// Wrap the rendering in a function:
const render = Component => {
  ReactDOM.render(
    // Wrap App inside AppContainer
    <AppContainer>
      <NextApp/>
    </AppContainer>,
    document.getElementById('root')
  );
};

// Always load the current deployed version instead of serving a cached app shell.
unregisterServiceWorker();

// Render once
render(NextApp);

// Webpack Hot Module Replacement API
if (module.hot) {
  module.hot.accept('./NextApp', () => {
    render(NextApp);
  });
}
